import { render, staticRenderFns } from "./ModalPrize.vue?vue&type=template&id=fb5d003a&scoped=true"
import script from "./ModalPrize.vue?vue&type=script&lang=js"
export * from "./ModalPrize.vue?vue&type=script&lang=js"
import style0 from "./ModalPrize.vue?vue&type=style&index=0&id=fb5d003a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5d003a",
  null
  
)

export default component.exports